import { SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_UPDATE_DELIVERY_DATE_PATH_SUFFIX = "/delivery-date/update";
/** /customer/subscription/delivery-date/update */
export const SUBSCRIPTIONS_CUSTOMER_UPDATE_DELIVERY_DATE_PATH = `${SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH}${SUBSCRIPTIONS_CUSTOMER_UPDATE_DELIVERY_DATE_PATH_SUFFIX}`;
